import isFunction from 'lodash-es/isFunction';

inputExtraPaymentsDirective.$inject = [];

export function inputExtraPaymentsDirective() {
    return {
        // language=HTML
        template: `
            <div>
                <p>Extra Payments</p>

                <div class="form-row" ng-repeat="payment in value.extra_payments">
                    <app-input-select class="flex-25"
                                      label="Type"
                                      hint="{{ hint }}"
                                      value="payment.type">
                        <md-option ng-value="extraPaymentTypes.addition">Addition</md-option>
                        <md-option ng-value="extraPaymentTypes.reduction">Reduction</md-option>
                    </app-input-select>

                    <app-input-text class="flex-25"
                                    label="Description"
                                    name="description"
                                    value="payment.description"
                                    required>
                    </app-input-text>

                    <app-input-currency class="flex-25"
                                        label="Amount"
                                        name="amount"
                                        min="0"
                                        max="10000"
                                        step="1"
                                        value="payment.amount">
                    </app-input-currency>

                    <app-input-text class="flex-25"
                                    label="Pay Element Code"
                                    name="pay_element_code"
                                    value="payment.pay_element_code">
                    </app-input-text>

                    <md-icon ng-click="removePayment($index)">
                        close
                    </md-icon>
                </div>

                <md-button class="md-raised md-primary"
                           ng-click="addPayment()">
                    Add Payment
                </md-button>
            </div>
        `,
        scope: {
            dispatchChange: '&?change',
            value: '=value',
        },
        link: function (scope) {
            scope.extraPaymentTypes = {
                addition: 'addition',
                reduction: 'reduction',
            };

            scope.type = 'addition';

            scope.$watch('value.extra_payments', (newValue, oldValue) => {
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                    _onChange();
                }
            });

            /** Methods */
            scope.addPayment = _addPayment;
            scope.removePayment = _removePayment;

            function _removePayment($index) {
                scope.value.extra_payments.splice($index, 1);
            }

            function _addPayment() {
                if (!scope.value.extra_payments) {
                    scope.value.extra_payments = [];
                }

                scope.value.extra_payments.push({
                    type: scope.extraPaymentTypes.payment,
                    description: '',
                    amount: 0,
                    pay_element_code: null
                });
            }

            function _onChange() {
                if (isFunction(scope.dispatchChange)) {
                    scope.dispatchChange({
                        value: scope.value,
                    });
                }
            }
        },
    };
}
